import { useState, useRef, useCallback } from "react";
import axios from "axios";
import debounce from "lodash/debounce";
import { API } from "@/lib/api";
import { MapPin } from "lucide-react";

export const CommuneAutocomplete = ({ onSelect, placeholder, testId }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const fetchResults = useRef(
    debounce(async (q) => {
      if (q.trim().length < 2) {
        setResults([]);
        return;
      }
      try {
        const r = await axios.get(`${API}/communes`, { params: { q } });
        setResults(r.data);
        setOpen(true);
      } catch (e) {
        setResults([]);
      }
    }, 220)
  ).current;

  const onChange = useCallback(
    (e) => {
      const v = e.target.value;
      setQuery(v);
      setSelected(null);
      onSelect(null);
      fetchResults(v);
    },
    [fetchResults, onSelect]
  );

  const choose = (c) => {
    setSelected(c);
    setQuery(`${c.commune} (${c.departement})`);
    setOpen(false);
    setResults([]);
    onSelect(c);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        className="pc-input"
        data-testid={testId}
        value={query}
        onChange={onChange}
        onFocus={() => results.length && setOpen(true)}
        placeholder={placeholder || "Nom de commune ou code INSEE"}
        autoComplete="off"
      />
      {open && results.length > 0 && (
        <ul
          data-testid={`${testId}-results`}
          style={{
            listStyle: "none", margin: "0.35rem 0 0", padding: "0.3rem",
            position: "absolute", zIndex: 20, width: "100%", background: "var(--surface)",
            border: "1px solid var(--line)", borderRadius: 12,
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)", maxHeight: 300, overflowY: "auto",
          }}
        >
          {results.map((c) => (
            <li key={c.code_insee}>
              <button
                type="button"
                data-testid={`commune-option-${c.code_insee}`}
                onClick={() => choose(c)}
                style={{
                  width: "100%", textAlign: "left", background: "transparent", border: "none",
                  padding: "0.55rem 0.6rem", borderRadius: 8, cursor: "pointer",
                  display: "flex", alignItems: "center", gap: "0.55rem", fontSize: "0.95rem",
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <MapPin size={16} color="var(--muted)" />
                <span>
                  <strong style={{ fontWeight: 600 }}>{c.commune}</strong>{" "}
                  <span style={{ color: "var(--muted)" }}>· {c.departement} · {c.code_insee}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
